<template>
  <v-card class="mx-4" style="width: 100%">
    <v-card-title> Conteo de Visitas </v-card-title>
    <v-card-text class="d-flex flex-row">
      <v-layout>
        <v-row>
          <v-col cols="12" xs="12" md="6">
            <widget
              icon="mdi-book-open-page-variant"
              :title="visitas.loginEstudiante ? visitas.loginEstudiante : 0"
              subTitle="Total de Visitas"
              supTitle="ESTUDIANTES"
              color="#00b297"
            />
          </v-col>
          <v-col cols="12" xs="12" md="6">
            <widget
              icon="mdi-factory"
              :title="visitas.loginEgresado ? visitas.loginEgresado : 0"
              subTitle="Total de Visitas"
              supTitle="EGRESADOS"
              color="#311B92"
            />
          </v-col>
        </v-row>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {
    Widget: () => import('@/components/admin/information/InfoCard')
  },

  methods: {
    ...mapActions('admin', ['fetchEstadisticasLogin'])
  },

  data() {
    return {
      visitas: {
        loginEstudiante: -1,
        loginEgresado: -1
      }
    }
  },

  async mounted() {
    this.visitas = { ...(await this.fetchEstadisticasLogin()) }
    console.log('this.visitas:', this.visitas)
  }
}
</script>

<style>
</style>